import React from 'react';
import './scss/styles.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,NavLink
} from "react-router-dom";
import Home from './components/Home'
import List from './components/List'
import data from './data/database'
import bigData from './data/databasebig'
import Contact from './components/Contact'
import Details from './components/Details'
import ListBig from './components/ListBig'
import Error from './components/Error'

function App() {
  return (
    <Router>
      <header>
        <div className="logo">
          <Link to="/">MICHAL ŠOUN</Link>
        </div>
        <nav>
          <ul>
            <li><NavLink to="/feature-films">feature films</NavLink></li>
            <li><NavLink to="/commercials">commercials</NavLink></li>
            <li><NavLink to="/tv-series">tv series</NavLink></li>
            <li><NavLink to="/contact">contact</NavLink></li>
          </ul>
        </nav>
      </header>
      <section>
        <Switch>
          <Route exact path="/feature-films">
            <List data={data.film} />
          </Route>
          <Route exact path="/commercials">
            <List data={data.commercials} />
          </Route>
          <Route exact path="/tv-series">
            <List data={data.series} />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>
          <Route exact path="/dev-list">
            <ListBig data={bigData.film} />
          </Route>
          <Route exact path="/dev-details">
            <Details data={bigData.film[0]} />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route  path="/">
            <Error />
          </Route>
        </Switch>
      </section>
    </Router>
  );
}

export default App;
